<script setup>
  import { defineAsyncComponent, ref } from 'vue'

  const props = defineProps(['icon', 'icon-class'])

  const hasSvg = ref(true)

  // Try to load the SVG, set hasSvg to false if it fails
  const Icon = defineAsyncComponent({
    loader: () => import(`@/assets/icons/sidebar/${props.icon}.svg`),
    onError: () => {
      hasSvg.value = false
    },
  })
</script>

<template>
  <Icon v-if="icon && hasSvg" />

  <i v-else-if="iconClass" :class="iconClass" />
  <i v-else class="pi pi-cog not-set-icon" />
</template>

<style lang="scss" scoped></style>
